import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import "../Careers/career.scss";

const Details = () => {
    const location = useLocation();
    const parameters = location.state;
    const [jobDetails] = useState(parameters && parameters.details);

    return (
        <>
            <div className="detail-wrapper">
                <div>
                    <h2>{jobDetails.post}</h2>
                    <div className="location">
                        <i className="icon-location"></i>
                        {jobDetails.location}
                    </div>

                    <div className="term">
                        <div>
                            <div>Terms</div>
                            <div>{jobDetails.terms}</div>
                        </div>

                        <div>
                            <div>Posted</div>
                            <div>{jobDetails.date}</div>
                        </div>
                    </div>

                    <div className="button-wrapper">
                        <div className="btn apply-job-btn">
                            <a href="/careers">Back</a>
                        </div>

                        <div className="btn apply-job-btn">
                            <a
                                href={`mailto:careers@yslearn.in?subject=career : ${jobDetails.post}`}
                            >
                                Apply for this Positon
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="LegalsPage">
                <div className="terms section-wrapper">
                    <div>
                        <h5>Co-Inventing the LMS Landspace</h5>
                        <p>
                            It is a long established fact that a reader will be
                            distracted by the readable content of a page when
                            looking at its layout. The point of using Lorem
                            Ipsum is that it has a more-or-less normal
                            distribution of letters, as opposed to using
                            'Content here, content here', making it look like
                            readable English. Many desktop publishing packages
                            and web page editors now use Lorem Ipsum as their
                            default model text, and a search for 'lorem ipsum'
                            will uncover many web sites still in their infancy.
                            Various versions have evolved over the years,
                            sometimes by accident, sometimes on purpose
                            (injected humour and the like).
                        </p>
                    </div>
                    <div>
                        <h5>The Role</h5>
                        <p>
                            It is a long established fact that a reader will be
                            distracted by the readable content of a page when
                            looking at its layout. The point of using Lorem
                            Ipsum is that it has a more-or-less normal
                            distribution of letters, as opposed to using
                            'Content here, content here', making it look like
                            readable English. Many desktop publishing packages
                            and web page editors now use Lorem Ipsum as their
                            default model text, and a search for 'lorem ipsum'
                            will uncover many web sites still in their infancy.
                            Various versions have evolved over the years,
                            sometimes by accident, sometimes on purpose
                            (injected humour and the like).
                        </p>
                    </div>
                    <div>
                        <h5>What We Value</h5>
                        <ul>
                            <li>
                                It is a long established fact that a reader will
                                be distracted by the readable content of a page
                                when looking at its layout. The point of using
                                Lorem Ipsum is that it has a more-or-less normal
                                distribution of letters.
                            </li>
                            <li>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have suffered
                                alteration in some.
                            </li>
                            <li>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have suffered
                                alteration in some.
                            </li>
                            <li>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have suffered
                                alteration in some.
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h5>Duties &amp; Responsibilities</h5>
                        <p>
                            Duties and Responsibilites for this job role goes here.
                        </p>
                    </div>

                    <div className="button-wrapper">
                        <div className="btn apply-job-btn">
                            <a
                                href={`mailto:careers@yslearn.in?subject=career : ${jobDetails.post}`}
                            >
                                Apply for this Positon
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Details;
